<ng-template ngFor let-anexa [ngForOf]="anexe" let-i="index">
  <tr
    class="cursor-pointer"
    (click)="openEditModal(anexa, i)"
    [ngClass]="{ active: selectedItem === i }"
  >
    <td class="text-primary">
      <div class="fs-4 d-flex justify-content-between">
        <div>
          {{ anexa.tip_reproductie_text }}
          din
          {{ anexa.interval_monta }}
        </div>

        <div [ngSwitch]="anexa?.status" class="ml-2">
          <span class="badge badge-warning" *ngSwitchCase="0"
            >În așteptare</span
          >
          <span class="badge badge-secondary" *ngSwitchCase="1"
            >Verificare</span
          >
          <span class="badge badge-secondary" *ngSwitchCase="2">Operare</span>
          <span class="badge badge-success" *ngSwitchCase="3">Validat</span>
          <span class="badge badge-danger" *ngSwitchCase="4">Refuzat</span>
        </div>
      </div>

      <div class="d-flex flex-wrap align-items-center">
        <div
          *ngFor="let animal of anexa.animale"
          class="d-flex align-items-center mr-2"
        >
          <ng-container [ngSwitch]="animal.sex">
            <div *ngSwitchCase="1" class="box-mascul">M</div>
            <div *ngSwitchCase="2" class="box-femela">F</div>
          </ng-container>

          <div
            [ngClass]="{
              'color-mascul': animal.sex === 1,
              'color-femela': animal.sex === 2
            }"
          >
            {{ animal.numarmatricol }}
          </div>
        </div>

        <div *ngIf="anexa.nr_femele > 1" class="fs-4">
          și {{ anexa.nr_femele }} femele
        </div>
      </div>
    </td>
  </tr>
</ng-template>

<tr *ngIf="newItem" class="active text-center">
  <td>
    <div class="mx-4 my-1 fs-3">
      Reproducție nouă
    </div>
  </td>
</tr>
